import { createFromIconfontCN } from '@ant-design/icons'
import cls from 'classnames'
import React from 'react'
import style from './style.module.less'
import { EDITTEXT } from './constant'
import Tracker from '@components/Tracker'

const MerchantIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_521417_bd10k6p08vt.js'
})

export const EditIcon = ({ isPro, type }) => {
  return (
    <>
      <div className={style.edit}>
        {isPro ? (
          <MerchantIcon
            type="icon-edit_qijian_16_16"
            className={style.iconPro}
          />
        ) : (
          <MerchantIcon className={style.icon} type="icon-edit_blue_16_16" />
        )}
        {EDITTEXT[type] ? (
          <Tracker
            mode={['hit']}
            data={Tracker.trackBuild(
              `酒店店铺装修页-店铺装修-${EDITTEXT[type]}-点击`
            )}
          >
            <span
              className={cls({ [style.text]: true, [style.textPro]: isPro })}
            >
              {EDITTEXT[type]}
            </span>
          </Tracker>
        ) : (
          <span className={cls({ [style.text]: true, [style.textPro]: isPro })}>
            编辑
          </span>
        )}
      </div>
    </>
  )
}

export const RejectIcon = () => {
  return (
    <>
      <div className={style.reject}>
        <MerchantIcon className={style.icon} type="icon-alert_outline_16_16" />
        <span className={style.text}>审核不通过</span>
      </div>
    </>
  )
}

export const VerifyingIcon = () => {
  return (
    <>
      <div className={style.verifying}>
        <MerchantIcon className={style.icon} type="icon-more_16_16" />
        <span className={style.text}>审核中</span>
      </div>
    </>
  )
}
